import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './dtos/create-vehicle-make.dto';
export * from './dtos/update-vehicle-make.dto';
export * from './dtos/vehicle-make-list.dto';
export * from './dtos/vehicle-make-record.dto';
export * from './dtos/vehicle-make-search.dto';
export * from './dtos/vehicle-makes-stats.dto';

export * from './types/vehicle-makes-filters';

export * from './validators/schemas/create-vehicle-make.schema';
export * from './validators/schemas/update-vehicle-make.schema';

export const vehicleMakeValidators = { canCreateOrUpdate };
